import { render, staticRenderFns } from "./lista-oficial-dbs.vue?vue&type=template&id=0a95fcbe"
import script from "./lista-oficial-dbs.vue?vue&type=script&lang=js"
export * from "./lista-oficial-dbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports